"use strict";
class LanguageEntry {
}
exports.LanguageEntry = LanguageEntry;
class LanguageEntryList {
    get(id) {
        return this.Texts[id] != null ? this.Texts[id] : id;
    }
    get keys() {
        let result = new Array();
        for (var key in this.Texts) {
            result.push(key);
        }
        return result;
    }
    add(id, text) {
        this.Texts[id] = text;
    }
    addEntry(entry) {
        this.Texts[entry.Id] = entry.Text;
    }
    constructor() {
        this.Texts = {};
    }
}
exports.LanguageEntryList = LanguageEntryList;
class MotionTextTable {
    constructor() {
        this.Language = {};
    }
    hasLanguage(lng) {
        return this.Language[lng] != null;
    }
}
exports.MotionTextTable = MotionTextTable;
